import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-package",
  "use": "icon-package-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-package\"><defs><style type=\"text/css\"></style></defs><path d=\"M889 303v556H141V303h748m20-80H121c-33.1 0-60 26.9-60 60v596c0 33.1 26.9 60 60 60h788c33.1 0 60-26.9 60-60V283c0-33.1-26.9-60-60-60z\" fill=\"#070707\" p-id=\"3083\" /><path d=\"M943 175v48H80v-48h863m20-80H60c-33.1 0-60 26.9-60 60v88c0 33.1 26.9 60 60 60h903c33.1 0 60-26.9 60-60v-88c0-33.1-26.9-60-60-60zM617 445v24H406v-24h211m20-80H386c-33.1 0-60 26.9-60 60v64c0 33.1 26.9 60 60 60h251c33.1 0 60-26.9 60-60v-64c0-33.1-26.9-60-60-60z\" fill=\"#070707\" p-id=\"3084\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/package.svg
// module id = 8XOL
// module chunks = 35